"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconAndroid = Experimental__IconAndroid;
exports.IconAndroid = IconAndroid;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconAndroid/index.tsx)
 */
function IconAndroid(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M14.688 9.13a8.144 8.144 0 0 1 1.287 2.804c.138.561-.319 1.066-.896 1.066H.919c-.578 0-1.032-.504-.894-1.065a8.164 8.164 0 0 1 .69-1.833 8.245 8.245 0 0 1 2.96-3.186L3.67 6.91l-.978-1.685-.346-.598a.75.75 0 0 1 1.297-.752l1.324 2.283.05.087a8.197 8.197 0 0 1 2.898-.56H8c1 0 1.99.181 2.924.536l.074.03.055-.094 1.324-2.282a.75.75 0 0 1 1.298.752L12.35 6.91l-.008.016a8.224 8.224 0 0 1 2.347 2.205ZM4.491 9.08c-.397-.261-.976-.078-1.302.408-.326.493-.267 1.103.13 1.373.398.262.977.079 1.302-.407.326-.493.268-1.104-.13-1.373Zm7.32.008c-.398.27-.456.88-.13 1.373.325.486.904.67 1.301.407.398-.269.457-.88.13-1.372-.325-.486-.905-.67-1.302-.408Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M21.197 13.5c.83 1.2 1.43 2.553 1.769 3.985.19.798-.438 1.515-1.233 1.515H2.264c-.795 0-1.42-.716-1.23-1.514a11.8 11.8 0 0 1 .95-2.604 11.576 11.576 0 0 1 4.068-4.527l-.006-.01L4.702 7.95l-.477-.85a1.098 1.098 0 0 1-.104-.808 1.07 1.07 0 0 1 .315-.526 1.001 1.001 0 0 1 1.135-.157c.183.093.335.24.437.422L7.83 9.275l.07.124a10.95 10.95 0 0 1 3.984-.794H12a10.942 10.942 0 0 1 4.02.76l.102.043.075-.134 1.821-3.243a1.03 1.03 0 0 1 .626-.46.999.999 0 0 1 .76.113c.23.138.4.362.474.626.074.264.047.547-.076.79l-1.82 3.244-.013.023a11.522 11.522 0 0 1 3.228 3.134Zm-14.021-.07c-.546-.372-1.344-.11-1.791.58-.448.7-.367 1.567.18 1.95.545.373 1.342.112 1.79-.578.447-.7.367-1.569-.18-1.951Zm10.063.011c-.546.383-.626 1.252-.178 1.95.447.692 1.243.953 1.79.58.546-.383.627-1.25.18-1.95-.449-.691-1.246-.953-1.792-.58Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconAndroid is deprecated and will be archived soon. Use IconAndroid instead.
 */
function Experimental__IconAndroid(props) {
  return /*#__PURE__*/_react["default"].createElement(IconAndroid, props);
}